<div class="container-fluid">
    <div class="row">
        <div class="col-4" *ngFor="let item of notificationsList" >
            
            <div class="card" style="padding: 10px; border-radius: 10px;">
                <p *ngIf="item.read == false" style="text-align: end;"> <span style="color: red;">New</span></p>
                <p><b>From:</b> {{item.from.name}}</p>
                <p><b>To:</b> {{item.to.name}}</p>
                <p><b>Title:</b> {{item.title}}</p>
                <p><b>Content:</b> {{item.content}}</p>
                <p><b>Bank Name:</b> {{item.Bank_Name}}</p>
                <p><b>Customer Name:</b> {{item.Customer_Name}}</p>
                <!-- <p><b>FV Feedback:</b> {{item.FV_Feedback}}</p> -->
                <p><b>FintId:</b> {{item.FintId}}</p>
                <p><b>Portfolio Name:</b> {{item.Portfolio_Name}}</p>
                <p><b>Date:</b> {{item.updatedAt}}</p>
                <div class="row justify-content-between">
                <a *ngIf="item.view == true" class="btn btn-sm btn-dark" (click)="viewnotification(item.link)">view</a>
                <!-- <a class="btn btn-sm btn-dark" *ngIf="item.view == false" (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">view</a> -->
                <button class="btn btn-sm btn-danger justify-content-between" (click)="clearNotification(item._id)">Remove</button>
            
               </div>
            </div>
            
        </div>      
       
    </div>
    <div >
        
    </div>
</div>





<!-- <a class="btn btn-sm btn-dark" *ngFor="let data of saved_Fields" (click)="getCustomer1('/admin_panel/user/createuser?_id='+data.finterstal_id,data)">view</a> -->
               



